// Templates display the age like 'age x' or 'x ans',
// so we don't need to be aware of language here.

angular.module('wbFilters').filter('age', () => (target, dateOfBirth) => {
  return moment(target).diff(dateOfBirth, 'years');
});
